// extracted by mini-css-extract-plugin
export default {"item":"SidebarMenuItem_item__JPFsQ","icon":"SidebarMenuItem_icon__Yvmfu","text":"SidebarMenuItem_text__5UK6x","counter":"SidebarMenuItem_counter__0XB5n"};